module.exports = __webpack_public_path__ + "static/media/APE.35bbfa8a.png";